<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold d-flex padding-sm align-items-center text-sm justify-content-between catalogo-text"
          >
            Empresa
            <router-link :to="{ name: 'Empresas' }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>
          <CCardBody v-if="isLoadingPage">
            <div class="w-100 d-flex justify-content-center align-items-center">
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>
          </CCardBody>
          <CCardBody v-else>
            <CRow>

            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput
                  :value="nombreEmpresa"
                  v-model="nombreEmpresa"
                  :isValid="checkIfValid('nombreEmpresa')"
                  label="Nombre de la empresa:"
                  placeholder="Nombre..."
                  invalidFeedback="Campo requerido, debe tener al menos 2 caracteres y maximo 100 caracteres"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput
                  :value="razonSocial"
                  v-model="razonSocial"
                  :isValid="checkIfValid('razonSocial')"
                  label="Razón social:"
                  placeholder="Razón social..."
                  invalidFeedback="Campo requerido, debe tener al menos 2 caracteres y maximo 100 caracteres"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput
                  :value="rfc"
                  v-model="rfc"
                  :isValid="checkIfValid('rfc')"
                  label="RFC:"
                  placeholder="RFC..."
                  invalidFeedback="Campo requerido, debe tener al menos 2 caracteres y maximo 20 caracteres"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput
                  :value="registroPatronal"
                  v-model="registroPatronal"
                  :isValid="checkIfValid('registroPatronal')"
                  label="Registro patronal:"
                  placeholder="Registro patronal..."
                  invalidFeedback="Campo requerido, debe tener al menos 2 caracteres y maximo 20 caracteres"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <input
                  ref="imgTr"
                  @change="inputFile"
                  type="file"
                  label="Unidad extra:"
                  placeholder="Image..."
                />
              </CCol>
            </CRow>
            <img class="sp-width" :src="url" :alt="urlName" />
            <!-- <img width="50" height="50" src="data:image/png;base64, YOUR_BASE64_STRING_FROM_RESPONSE" :alt="urlName" /> -->
            <ExtraConfigInput
              title="de la empresa"
              parametro="empresas_atributos_extras"
              v-model="fieldsExtra"
              @config="config => fieldsExtraConfig = config"
              @onValid="v=>valid=v"
            />
          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <router-link :to="{ name: 'Empresas' }">
              <CButton class="px-4 mx-3 btn-lg" color="danger">Cancelar</CButton>
            </router-link>

            <CButton class="px-4 mx-3 btn-lg" @click="addEmpresa()" color="success">
              <div v-if="isLoading">
                <div class="w-100 d-flex justify-content-center align-items-center">
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
              <span v-else>Guardar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
    <CModal
      size="sm"
      title="Empresas"
      :centered="true"
      color="warning"
      :show="warningModal"
    >{{ error }}</CModal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import ExtraConfigInput from './../../customComponents/ExtraConfigInput.vue'
import "vue-select/dist/vue-select.css";

export default {
  name: "EditarEmpresa",

  components: {
    ExtraConfigInput
  },

  data() {
    return {
      id: this.$route.params.id,
      item: {},
      nombreEmpresa: "",
      razonSocial: "",
      rfc: "",
      registroPatronal: "",
      isLoading: false,

      url: "",
      urlName: "",
      warningModal: false,
      error: "",
      fieldsExtraConfig: [],
      fieldsExtra: {},
      isLoadingPage: false,
      isLoadingCombos: false,
      valid: {flag: true}
    };
  },

  mixins: [validationMixin],
  validations: {
    nombreEmpresa: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(100)
    },

    razonSocial: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(100)
    },

    rfc: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(20)
    },

    registroPatronal: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(20)
    }
  },

  computed: {
    isValidEmpresa() {
      return !this.nombreEmpresa.$invalid;
    },
    isValidRazonSocial() {
      return !this.razonSocial.$invalid;
    },
    isValidRfc() {
      return !this.rfc.$invalid;
    },
    isValidRegistroPatronal() {
      return !this.registroPatronal.$invalid;
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    },
    ubicacionRaizValue() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    }
  },

  created() {
    this.isLoadingPage = true;
    const tra = [
      this.$store.dispatch("customHTTP", {
        schema: "empresas",
        filter: {
          where: [
            {
              field: "id",
              value: this.id,
              operator: "="
            }
          ]
        }
      })
    ];

    Promise.all(tra)
      .then(([item]) => {
        this.item = item.data[0];
        this.nombreEmpresa = this.item.payload.nombre;
        this.razonSocial = this.item.payload.razon_social;
        this.rfc = this.item.payload.rfc;
        this.registroPatronal = this.item.payload.registro_patronal;
        if(this.item.payload.extras !== undefined){
          let fieldsExtraPayload = Object.entries(this.item.payload.extras);
          for (let index = 0; index < fieldsExtraPayload.length; index++) {
            const fieldExtra = fieldsExtraPayload[index];
            this.fieldsExtra[fieldExtra[0]] = fieldExtra[1]
          }
        }
        if (this.item.payload.fotografia) {
          this.getImage(this.item.payload.fotografia.media);
        }
      })
      .finally(() => (this.isLoadingPage = false));
  },

  methods: {
    inputFile(e) {
      let reader = new FileReader();
      this.url = "";
      this.urlName = "";

      reader.onload = file => {
        this.url = file.target.result;
        this.urlName = e.target.files[0].name;
      };

      reader.readAsDataURL(e.target.files[0]);
      //  this.$emit('input', this.value);
    },

    addEmpresaFull(agregarEmpresa) {
      this.isLoading = true;
        
      this.$store
        .dispatch("customActualizarHTTP", agregarEmpresa)
        .then(() => {
          this.currentAlertCounter = 6;
        })
        .catch(rej => {
          // console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
        })

        .finally(() => {
          this.isLoading = false;
        });
    },

    addEmpresa() {
      this.validateEmpresa();
     
      if(!this.valid.flag){
        const valores = this.valid.valores
        this.error = `Son requeridos los campos: ${valores.join(', ')}`;
        this.warningModal=true
      }
      if (
        this.isValidEmpresa &&
        this.isValidRazonSocial &&
        this.isValidRfc &&
        this.isValidRegistroPatronal
      ) {
        this.isLoading = true;
        
        this.fieldsExtraConfig.forEach(indexField => {
          if (indexField.tipo === "number") {
            this.fieldsExtra[indexField.nombre] =
              Number(this.fieldsExtra[indexField.nombre]) || 0;
          }
          if (indexField.tipo === "text") {
            this.fieldsExtra[indexField.nombre] =
              this.fieldsExtra[indexField.nombre] || "";
          }
        });

        const agregarEmpresa = {
          schema: "empresas",
          id: this.id,
          payload: {
            nombre: this.nombreEmpresa,
            razon_social: this.razonSocial,
            rfc: this.rfc,
            registro_patronal: this.registroPatronal
          }
        }


        if (this.fieldsExtraConfig.length > 0) {
          agregarEmpresa.payload.extras = this.fieldsExtra;
        }
        let img = this.$refs.imgTr;
        if (img.files[0]) {
          let formData = new FormData();
          formData.append("media", img.files[0]);

          this.$store
            .dispatch("customImageHTTP", formData)
            .then(res => {
              console.log(res.data);
              agregarEmpresa.payload.fotografia = res.data
              this.addEmpresaFull(agregarEmpresa);
            })
            .catch(rej => {
              console.log(rej);
            })

            .finally(() => {
              this.isLoading = true;
            });
        } else {
          this.$store
            .dispatch("customActualizarHTTP", agregarEmpresa)
            .then(() => {
              this.$router.push({ name: "Empresas" });
            })
            .catch(rej => {
              // console.log(rej);
              this.error = rej.message;
              this.warningModal = true;
            })

            .finally(() => {
              this.isLoading = false;
            });
        }
      }
    },
    addTrabajadorFull(imgData) {
      this.isLoading = true;
      this.$store
        .dispatch("customActualizarHTTP", {
          schema: "empresas",
          id: this.id,
          payload: {
            nombre: this.nombreEmpresa,
            razon_social: this.razonSocial,
            rfc: this.rfc,
            registro_patronal: this.registroPatronal,
            fotografia: imgData
          }
        })
        .then(() => {
          // console.log(res.data);
          this.$router.push({ name: "Trabajadores" });
        })
        .catch(rej => {
          console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
        })

        .finally(() => {
          this.isLoading = false;
        });
    },
    getImage(media) {
      this.isLoading = true;
      this.$store
        .dispatch("customImageObtenerHTTP", {
          media: media
        })
        .then(blob => {
          // this.url = `data:image/png;charset=utf-8;base64, ${res}`;
          // const b64Response = btoa(unescape(encodeURIComponent(blob)));

          // console.log(b64Response);

          // const str2 = decodeURIComponent(escape(window.atob(b64Response)));
          // console.log(str2);

          // let reader = new FileReader();
          // reader.onloadend = function() {
          //   this.url = reader.result;
          // };
          // reader.readAsDataURL(res);
          //this.url = `data:image/jpg;charset=utf-8;base64, ${b64Response}`;
          this.url = window.URL.createObjectURL(blob);
          // this.url = blob;
        })
        .catch(rej => {
          console.log(rej);
        })

        .finally(() => {
          this.isLoading = false;
        });
    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field === "");
    },
    validateEmpresa() {
      this.nombreEmpresa;
      this.razonSocial;
      this.rfc;
      this.registroPatronal;
      // this.equivalencia_6oz;
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.sp-width {
  max-width: 400px !important;
  height: auto !important;
  /* object-fit: contain; */
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
